import { gql } from "@apollo/client";

import { CALL_PLAN_INFO } from "@/graphql-client/fragments";

export const CREATE_CALL_PLAN_MUTATION = gql`
  mutation CreateCallPlan($input: CreateCallPlanInput!) {
    createCallPlan(input: $input) {
      ...CallPlanInfo
    }
  }
  ${CALL_PLAN_INFO}
`;

export const UPDATE_CALL_PLAN_MUTATION = gql`
  mutation UpdateCallPlan($input: UpdateCallPlanInput!) {
    updateCallPlan(input: $input) {
      ...CallPlanInfo
    }
  }
  ${CALL_PLAN_INFO}
`;

export const DELETE_CALL_PLAN_MUTATION = gql`
  mutation DeleteCallPlan($id: Int!) {
    deleteCallPlan(id: $id)
  }
`;
